export const REC_FILLER_POSTFIX = ':filler';

export const REC_EXTRA_POSTFIX = ':extra';
